<template>
  <div class="container-fluid">
    Modéle de page
  </div>
</template>

<script>

export default {
  name: "TemplatePage",
  mixins: [],
  components: {},
  data() {
    return {
      informations: []
    }
  },
  mounted() {    
    
  },
  methods: {
    
  }
}
</script>
